import React from "react";
import ReactDOM from "react-dom";
import { TYPE_PC, TYPE_SP } from "../../common/defines";
import { modal } from "../modal";
import classnames from "classnames";
import { applyRoom } from "../../pages/area/util";
import { OptionButton } from "../../common/OptionButton";
import { Link } from "../../lib/Link";
import { isKyusyuuHokkaidou } from "../../lib/isKyusyuuHokkaidou"
import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown";
import Checkbox from "semantic-ui-react/dist/commonjs/modules/Checkbox";
import Table from "semantic-ui-react/dist/commonjs/collections/Table";
import masterData from "../../lib/masterData";
import api from "../../lib/api";
import { DateSelector } from "../DateSelector";
import moment from "moment";
import AreaStamp from "../../resource/base64/area-stamp";
import Before from "../../resource/base64/before";

import "react-datepicker/dist/react-datepicker.css";

const CARD = 3;
const BANK = 4;

const FELICA_CARD_PRICE = 1050;

const getFelicaCardCountOptions = (number) =>
_.times(number, (index) => ({
  key: index + 1,
  text: index + 1,
  value: index + 1,
}))

const getOptions = (number) =>
_.times(number, (index) => ({
  key: index,
  text: index,
  value: index,
}))

function toLocaleString(value) {
  return (value && value.toLocaleString && value.toLocaleString(value)) || 0;
}
/* eslint-disable complexity */

class ModalEstimate extends React.Component {
  constructor(props) {
    super(props);
    const userAgent = window.navigator.userAgent.toLowerCase();
    let isIEorEdgeorOghers = false;
    if (userAgent.indexOf('msie') != -1 ||
      userAgent.indexOf('trident') != -1) {
      isIEorEdgeorOghers = true;
    } else if (userAgent.indexOf('edge') != -1) {
      isIEorEdgeorOghers = true;
    } else if (userAgent.indexOf('chrome') != -1) {
    } else if (userAgent.indexOf('safari') != -1) {
    } else if (userAgent.indexOf('firefox') != -1) {
    } else if (userAgent.indexOf('opera') != -1) {
    } else {
      isIEorEdgeorOghers = true;
    }
    this.state = {
      params: {
        contractType: CARD,
        isIEorEdgeorOghers: isIEorEdgeorOghers,
      },
    };
    const { asset } = this.props;
    const params = Object.assign({}, this.defaultParams, this.state.params);
    const range = this.getRange({ asset, params });
    this.state = {
      params: {
        contractType: CARD,
        rackService: false,
        isIEorEdgeorOghers: isIEorEdgeorOghers,
        startDate: range.startDate.format("YYYY/MM/DD"),
        warrantyFlg: 1,
        rakurakuJou: 1,
        cardboardM: 0,
        cardboardL: 0,
        cardboardMDisabled: "disabled",
        cardboardLDisabled: "disabled",
        cardboardMOptions: getOptions(31),
        cardboardLOptions: getOptions(31),
        felicaCardCount: 1,
        felicaCardCountDisabled: "disabled",
        felicaCardCountOptins: getFelicaCardCountOptions(10),
        rackSmall: 0,
        rackMedium: 0,
        rackBig: 0,
        rackHanger: 0,
        caster: 0,
        storageCase: 0,
        storageboxSmall: 0,
        storageboxMedium: 0,
        rackSmallDisabled: "disabled",
        rackMediumDisabled: "disabled",
        rackBigDisabled: "disabled",
        rackHangerDisabled: "disabled",
        casterDisabled: "disabled",
        storageCaseDisabled: "disabled",
        storageboxSmallDisabled: "disabled",
        storageboxMediumDisabled: "disabled",
        rackSmallOptions: getOptions(11),
        rackMediumOptions: getOptions(11),
        rackBigOptions: getOptions(11),
        rackHangerOptions: getOptions(11),
        casterOptions: getOptions(11),
        storageCaseOptions: getOptions(21),
        storageboxSmallOptions: getOptions(21),
        storageboxMediumOptions: getOptions(21),
      },
    };
  }
  updateParams(params) {
    this.setState({ params: Object.assign({}, this.state.params, params) });
  }
  felicaCardCalculation(felicaCardCount) {
      const calString = felicaCardCount==0 ? ""
            : " × " + FELICA_CARD_PRICE + " 円(税込) = " + (FELICA_CARD_PRICE * felicaCardCount) + " 円(税込)";
      document.getElementById("felicaCardCalculation").innerHTML = calString;
  }
  showCampaignDetail(campaignId) {
    this.setState({ detailedCampaign: campaignId });
  }
  getParams(room) {
    return Object.assign(
      {
        campaign: room.primaryCampaign || room.campaigns && room.campaigns[0],
      },
      this.state.params
    );
  }
  async calculateEstimate() {
    const params = Object.assign({}, this.defaultParams, this.state.params);
    const room = Object.assign({}, this.props.room);

    if (!room) {
      this.setState({ showValidation: true });
      return;
    }


    const { asset } = this.props;

    const { startDate } = this.getRange({ asset, params });

    let p = Object.assign(this.getParams(room));
    const isBank = this.state.params.contractType == BANK ? true : false;
    if (isBank && Number(moment(p.startDate)) < Number(moment(startDate))) {
      p.startDate = Object.assign(startDate);
    }
    const isRackService = this.state.params.rackService == true ? true : false;
    if (isRackService && Number(moment(p.startDate)) < Number(moment(startDate))) {
      p.startDate = Object.assign(startDate);
    }
console.log(Object.assign({ startDate }, this.getParams(room)));
    const simulation = await api.simulation({
      asset,
      room,
      params: p,
    });
console.log(simulation);
    this.setState({
      simulation,
    });
    setTimeout(() => {
      const element = ReactDOM.findDOMNode(this.refs.simulation);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 100);
  }
  getRange({ asset, params }) {
    if (this.props.room.riyouKikanEnd) {
      const startDate = moment(this.props.room.riyouKikanEnd.replace(/-/g, "/"))
      const endDate = moment((parseInt(this.props.room.riyouKikanEnd.substring(0, 4)) + 1) + "/" +
        this.props.room.riyouKikanEnd.substring(5, 7) + "/" + this.props.room.riyouKikanEnd.substring(8, 10));
      return { startDate, endDate }
    } else {
      let startDate = moment(asset.recruitmentStartDate.replace(/-/g, "/"))
      if (params.contractType === CARD) {
        if (params.rackService === true){
          startDate = moment.max(startDate, moment(asset.recruitmentStartDateRackService));
        } else {
          startDate = moment.max(startDate, moment(asset.recruitmentStartDateCreditCard));
        }
      } else if (params.contractType === BANK) {
        startDate = moment.max(startDate, moment(asset.recruitmentStartDateBank));
      }
      const endDate = moment(asset.recruitmentEndDate);
      return { startDate, endDate }
    }
  }
  printOrder = () => {
    const wrapper = document.getElementById("wrapper");
    for (let i = 0; i < wrapper.children.length; i++) {
      wrapper.children[i].setAttribute("style", "display: none");
    }
    const printme = document.getElementById("printme");
    document.getElementById("button1").setAttribute("style", "display: none");
    document.getElementById("button2").setAttribute("style", "display: none");
    wrapper.appendChild(printme);
    window.print();
    for (let i = 0; i < wrapper.children.length; i++) {
      wrapper.children[i].removeAttribute("style");
    }
    wrapper.removeChild(printme);
    modal.closeModal();
  }
  GeneratePdfFromHtml = (asset, room, state, startDate, isPrint) => {
    pdfMake.fonts = {
      GenShin: {
        normal: "GenShinGothic-Normal-Sub.ttf",
        bold: "GenShinGothic-Normal-Sub.ttf",
        italics: "GenShinGothic-Normal-Sub.ttf",
        bolditalics: "GenShinGothic-Normal-Sub.ttf",
      },
    };
  
    const startDay = state.params.startDate !== undefined && state.params.startDate !== null ?
      state.params.startDate.substr(0, 4) + "年" + state.params.startDate.substr(5, 2) + "月" + state.params.startDate.substr(8, 2) + "日" :
      startDate.year() + "年" + (startDate.month() + 1) + "月" + startDate.date() + "日";
    const defaultStyle = "GenShin";
    let table_first_time = {
      table: {
        widths: ["*", "*"],
        body: [],
      }
    };
    let table_monthly = {
      table: {
        widths: ["*", "*"],
        body: [],
      }
    };

    const table_body_first_time = [
      ["事務手数料", toLocaleString(state.simulation.initialCost.commitionFee) + "円"],
      ["日割使用料(初月)", toLocaleString(state.simulation.initialCost.initialPrice) + "円"],
      ["管理費(初月)", toLocaleString(state.simulation.initialCost.admissionFee1) + "円"],
      ["使用料(次月)", toLocaleString(state.simulation.initialCost.priceMonth) + "円"],
      ["管理費(次月)", toLocaleString(state.simulation.initialCost.admissionFee2) + "円"],
    ];
    table_body_first_time.push(["安心保証パック(初月)", toLocaleString(state.simulation.initialCost.warranty1) + "円"]);
    table_body_first_time.push(["安心保証パック(次月)", toLocaleString(state.simulation.initialCost.warranty2) + "円"]);
    table_body_first_time.push(["室内整備料", toLocaleString(state.simulation.initialCost.room_mainte) + "円"]);
    table_body_first_time.push(["鍵買取料", toLocaleString(state.simulation.initialCost.keyPrice) + "円"]);
    if(state.simulation.initialCost.securityFee > 0) table_body_first_time.push(["セキュリティ登録料", toLocaleString(state.simulation.initialCost.securityFee) + "円"]);
    if(state.simulation.initialCost.rakuraku > 0) table_body_first_time.push(["ハロー宅配便", toLocaleString(state.simulation.initialCost.rakuraku) + "円"]);
    if(state.simulation.initialCost.packing > 0) table_body_first_time.push(["梱包サービスプラス", toLocaleString(state.simulation.initialCost.packing) + "円"]);
    if(state.simulation.initialCost.cardboard > 0) table_body_first_time.push(["梱包用段ボール", toLocaleString(state.simulation.initialCost.cardboard) + "円"]);
    if(state.simulation.initialCost.rackService > 0) table_body_first_time.push(["ラック販売・組み立てサービス", toLocaleString(state.simulation.initialCost.rackService) + "円"]);
    table_body_first_time.push(["Web申し込み割引", toLocaleString(state.simulation.initialCost.discountWeb) + "円"]);
    for (let a of table_body_first_time) {
      let tr = [];
      let isHeader = true;
      for (let v of a) {
        tr.push({
          text: v,
          fillColor: isHeader ? "#faf8f5" : "#fff",
          style: isHeader ? ["th"] : ["td"]
        });
        isHeader = !isHeader;
      };
      table_first_time["table"]["body"].push(tr);
    };

    const table_body_monthly = [
      ["月額使用料", toLocaleString(state.simulation.runningCost.priceMonth) + "円"],
      ["管理費", toLocaleString(state.simulation.runningCost.admissionFee) + "円"],
    ];
    table_body_monthly.push(["安心保証パック", toLocaleString(state.simulation.runningCost.warranty) + "円"]);
    for (let a of table_body_monthly) {
      let tr = [];
      let isHeader = true;
      for (let v of a) {
        tr.push({
          text: v,
          fillColor: isHeader ? "#faf8f5" : "#fff",
          style: isHeader ? ["th"] : ["td"]
        });
        isHeader = !isHeader;
      };
      table_monthly["table"]["body"].push(tr);
    };

    let doc = null;
    if (this.state.simulation.runningCostWithoutCampaign && this.state.simulation.runningCost.discountTotal > 0) {

      let table_monthly_with_normal = {
        table: {
          widths: ["*", "*"],
          body: [],
        }
      };

      const table_body_monthly_with_normal = [
        ["月額使用料", toLocaleString(state.simulation.runningCostWithoutCampaign.notCampaignPriceMonth) + "円"],
        ["管理費", toLocaleString(state.simulation.runningCostWithoutCampaign.notCampaignAdmissionFee) + "円"],
      ];
      if(state.simulation.runningCostWithoutCampaign.notCampaignWarranty > 0) table_body_monthly_with_normal.push(["安心保証パック", toLocaleString(state.simulation.runningCostWithoutCampaign.notCampaignWarranty) + "円"]);
      for (let a of table_body_monthly_with_normal) {
        let tr = [];
        let isHeader = true;
        for (let v of a) {
          tr.push({
            text: v,
            fillColor: isHeader ? "#faf8f5" : "#fff",
            style: isHeader ? ["th"] : ["td"]
          });
          isHeader = !isHeader;
        };
        table_monthly_with_normal["table"]["body"].push(tr);
      };



      doc = {
      info: {
        title: asset.name.replace("（","(").replace("）",")"),
        subject: asset.name.replace("（","(").replace("）",")"),
      },
      pageSize: "A4",
      pageMargins: [30, 30, 30, 10],
      content: [
        {
          text: asset.name.replace("（","(").replace("）",")") + (room.extent && " " + room.roomName + "号室") + (room.extent && " " + room.extent + "帖タイプお見積もり"),
          style: "header",
        },
        {
          columns: [
            {
              width: 3,
              height: 20,
              style: "image",
              image: "data:image/png;base64," + Before.BASE64,
              margin: [0, 13, 0, 20],
            },
            {
              text: "お見積り条件",
              style: "subheader",
              margin: [0, 10, 0, 20],
            },
          ],
          columnGap: 3
        },
        {
          columns: [
            {
              width: "65%",
              text: [
                {
                  text: "月々のお支払い方法",
                  style: "body2",
                },
                {
                  text: state.params.contractType == CARD ? "\n\nカード" : state.params.contractType == BANK ? "\n\n口座引き落し" : "",
                  style: "value",
                },
              ]
            },
            {
              width: 180,
              style: "image",
              image: "data:image/png;base64," + AreaStamp.BASE64,
            }
          ],
          columnGap: 3
        },
        {
          text: "ご利用開始日",
          margin: [0, 10, 0, 0],
          style: "body2",
        },
        {
          text: "※カードなら最短2日後、口座引き落しなら最短7日後からご利用いただけます。\n※北海道・九州・四国地方はカードの場合最短4日後、口座引き落としの場合最短10日後からご利用いただけます。\n\n",
          margin: [0, 10, 0, 0],
          style: "body",
        },
        {
          text: startDay,
          style: "value",
        },
        {
          columns: [
            {
              width: 3,
              height: 20,
              style: "image",
              image: "data:image/png;base64," + Before.BASE64,
              margin: [0, 23, 0, 2],
            },
            {
              text: "お見積り金額",
              style: "subheader",
              margin: [0, 20, 0, 2],
            },
          ],
          columnGap: 3
        },
        {
          text: "初回のお支払い",
          style: "tableheader",
          margin: [0, 0, 0, 10],
        },
        {
          table: {
            widths: ["*"],
            body: [
              [[{
                table: table_first_time["table"] ,
                margin: [5, 5, 5, 0],
              },
              {
                margin: [5, 5, 5, 5],
                table: {
                  widths: ["*", "*"],
                  body: [
                    [
                      {
                        text: "初回のお支払い",
                        style: "summary",
                      },
                      {
                        text: toLocaleString(state.simulation.initialCost.total) + "円",
                        style: "amount",
                      }
                    ],
                  ]
                }
              }]],
            ]
          }
        },
        {
          text: "月々のお支払い(キャンペーン適用中)",
          style: "tableheader",
          margin: [0, 10, 0, 10],
        },
        {
          table: {
            widths: ["*"],
            body: [
              [[{
                table: table_monthly["table"] ,
                margin: [5, 5, 5, 0],
              },
              {
                margin: [5, 5, 5, 5],
                table: {
                  widths: ["*", "*"],
                  body: [
                    [
                      {
                        text: "月々のお支払い",
                        style: "summary",
                      },
                      {
                        text: toLocaleString(state.simulation.runningCost.total) + "円",
                        style: "amount",
                      }
                    ],
                  ]
                }
              }]],
            ]
          }
        },
        {
          text: "月々のお支払い(キャンペーン適用終了後)",
          style: "tableheader",
          margin: [0, 10, 0, 10],
        },
        {
          table: {
            widths: ["*"],
            body: [
              [[{
                table: table_monthly_with_normal["table"] ,
                margin: [5, 5, 5, 0],
              },
              {
                margin: [5, 5, 5, 5],
                table: {
                  widths: ["*", "*"],
                  body: [
                    [
                      {
                        text: "月々のお支払い",
                        style: "summary",
                      },
                      {
                        text: toLocaleString(state.simulation.runningCostWithoutCampaign.notCampaignTotal) + "円",
                        style: "amount",
                      }
                    ],
                  ]
                }
              }]],
            ]
          }
        },
        {
          text: "※安心保証パックの詳細はこちら。",
          margin: [20, 10, 0, 0],
          style: "footer",
        },
        {
          text: "※計算結果は、目安の利用料金となります。詳しくはお問い合わせ下さい。",
          margin: [20, 0, 0, 0],
          style: "footer",
        },
        {
          text: "※鍵代は物件によっては発生致しません。詳細はお問合せの際にご確認下さい。",
          margin: [20, 0, 0, 0],
          style: "footer",
        },
        {
          text: "※月々の支払い方法がお引き落としの場合は、別途引落手数料が発生致します。",
          margin: [20, 0, 0, 0],
          style: "footer",
        },
        {
          text: "※お申込内容により、保証会社を付帯させていただく場合がございます(別途､保証委託料がかかります)。",
          margin: [20, 0, 0, 0],
          style: "footer",
        },
        {
          text: "※鍵買取料に関して、南京錠・交通系ICカード等の鍵購入費用が合算で表記されております。",
          margin: [20, 0, 0, 0],
          style: "footer",
        },
        {
            text: (state.simulation.initialCost.securityFee > 0 ? "※セキュリティカードキーが必要になる物件につきまして、カードキーはレンタルとなります。\n" : "")
                + (state.simulation.initialCost.total == 1 ? "※決済処理調整を行うため、1円での決済となります。": "　"),
          margin: [20, 0, 0, 0],
          style: "footer",
        },
        {
          text: "※表記はすべて「税込み価格」です。",
          margin: [20, 0, 0, 0],
          style: "footer",
        },
      ],
      defaultStyle: {
        font: defaultStyle,
      },
      styles: {
        header: {
          fontSize: 16,
          alignment: "center",
          bold: false,
        },
        subheader: {
          fontSize: 18,
          bold: true,
        },
        value: {
          fontSize: 10,
          bold: true,
        },
        image: {
          alignment: "right",
        },
        body: {
          fontSize: 10,
          bold: true,
        },
        body2: {
          fontSize: 18,
          bold: true,
        },
        tableheader: {
          fontSize: 14,
          alignment: "center",
          bold: true,
          color: "#000000",
        },
        th: {
          alignment: "left",
          bold: true,
        },
        td: {
          alignment: "right",
        },
        summary: {
          fontSize: 12,
          alignment: "center",
          bold: true,
          color: "#000000",
        },
        amount: {
          fontSize: 14,
          alignment: "right",
          bold: true,
          color: "#000000",
        },
        footer: {
          fontSize: 10,
          bold: true,
          color: "#000000",
        },
      },
    };

    } else {
      doc = {
      info: {
        title: asset.name.replace("（","(").replace("）",")"),
        subject: asset.name.replace("（","(").replace("）",")"),
      },
      pageSize: "A4",
      pageMargins: [30, 30, 30, 10],
      content: [
        {
          text: asset.name.replace("（","(").replace("）",")") + (room.extent && " " + room.roomName + "号室") + (room.extent && " " + room.extent + "帖タイプお見積もり"),
          style: "header",
        },
        {
          columns: [
            {
              width: 3,
              height: 20,
              style: "image",
              image: "data:image/png;base64," + Before.BASE64,
              margin: [0, 13, 0, 20],
            },
            {
              text: "お見積り条件",
              style: "subheader",
              margin: [0, 10, 0, 20],
            },
          ],
          columnGap: 3
        },
        {
          columns: [
            {
              width: "65%",
              text: [
                {
                  text: "月々のお支払い方法",
                  style: "body2",
                },
                {
                  text: state.params.contractType == CARD ? "\n\nカード" : state.params.contractType == BANK ? "\n\n口座引き落し" : "",
                  style: "value",
                },
              ]
            },
            {
              width: 180,
              style: "image",
              image: "data:image/png;base64," + AreaStamp.BASE64,
            }
          ],
          columnGap: 3
        },
        {
          text: "ご利用開始日",
          margin: [0, 10, 0, 0],
          style: "body2",
        },
        {
          text: "※カードなら最短2日後、口座引き落しなら最短7日後からご利用いただけます。\n※北海道・九州・四国地方はカードの場合最短4日後、口座引き落としの場合最短10日後からご利用いただけます。\n\n",
          margin: [0, 10, 0, 0],
          style: "body",
        },
        {
          text: startDay,
          style: "value",
        },
        {
          columns: [
            {
              width: 3,
              height: 20,
              style: "image",
              image: "data:image/png;base64," + Before.BASE64,
              margin: [0, 23, 0, 2],
            },
            {
              text: "お見積り金額",
              style: "subheader",
              margin: [0, 20, 0, 2],
            },
          ],
          columnGap: 3
        },
        {
          text: "初回のお支払い",
          style: "tableheader",
          margin: [0, 0, 0, 10],
        },
        {
          table: {
            widths: ["*"],
            body: [
              [[{
                table: table_first_time["table"] ,
                margin: [5, 5, 5, 0],
              },
              {
                margin: [5, 5, 5, 5],
                table: {
                  widths: ["*", "*"],
                  body: [
                    [
                      {
                        text: "初回のお支払い",
                        style: "summary",
                      },
                      {
                        text: toLocaleString(state.simulation.initialCost.total) + "円",
                        style: "amount",
                      }
                    ],
                  ]
                }
              }]],
            ]
          }
        },
        {
          text: "月々のお支払い",
          style: "tableheader",
          margin: [0, 10, 0, 10],
        },
        {
          table: {
            widths: ["*"],
            body: [
              [[{
                table: table_monthly["table"] ,
                margin: [5, 5, 5, 0],
              },
              {
                margin: [5, 5, 5, 5],
                table: {
                  widths: ["*", "*"],
                  body: [
                    [
                      {
                        text: "月々のお支払い",
                        style: "summary",
                      },
                      {
                        text: toLocaleString(state.simulation.runningCost.total) + "円",
                        style: "amount",
                      }
                    ],
                  ]
                }
              }]],
            ]
          }
        },
        {
          text: "※安心保証パックの詳細はこちら。",
          margin: [20, 10, 0, 0],
          style: "footer",
        },
        {
          text: "※計算結果は、目安の利用料金となります。詳しくはお問い合わせ下さい。",
          margin: [20, 0, 0, 0],
          style: "footer",
        },
        {
          text: "※鍵代は物件によっては発生致しません。詳細はお問合せの際にご確認下さい。",
          margin: [20, 0, 0, 0],
          style: "footer",
        },
        {
          text: "※月々の支払い方法がお引き落としの場合は、別途引落手数料が発生致します。",
          margin: [20, 0, 0, 0],
          style: "footer",
        },
        {
          text: "※お申込内容により、保証会社を付帯させていただく場合がございます(別途､保証委託料がかかります)。",
          margin: [20, 0, 0, 0],
          style: "footer",
        },
        {
          text: "※鍵買取料に関して、南京錠・交通系ICカード等の鍵購入費用が合算で表記されております。",
          margin: [20, 0, 0, 0],
          style: "footer",
        },
        {
          text: (state.simulation.initialCost.securityFee > 0 ? "※セキュリティカードキーが必要になる物件につきまして、カードキーはレンタルとなります。\n" : "")
                + (state.simulation.initialCost.total == 1 ? "※決済処理調整を行うため、1円での決済となります。": "　"),
          margin: [20, 0, 0, 0],
          style: "footer",
        },
        {
          text: "※表記はすべて「税込み価格」です。",
          margin: [20, 0, 0, 0],
          style: "footer",
        },
      ],
      defaultStyle: {
        font: defaultStyle,
      },
      styles: {
        header: {
          fontSize: 16,
          alignment: "center",
          bold: false,
        },
        subheader: {
          fontSize: 18,
          bold: true,
        },
        value: {
          fontSize: 10,
          bold: true,
        },
        image: {
          alignment: "right",
        },
        body: {
          fontSize: 10,
          bold: true,
        },
        body2: {
          fontSize: 18,
          bold: true,
        },
        tableheader: {
          fontSize: 14,
          alignment: "center",
          bold: true,
          color: "#000000",
        },
        th: {
          alignment: "left",
          bold: true,
        },
        td: {
          alignment: "right",
        },
        summary: {
          fontSize: 12,
          alignment: "center",
          bold: true,
          color: "#000000",
        },
        amount: {
          fontSize: 14,
          alignment: "right",
          bold: true,
          color: "#000000",
        },
        footer: {
          fontSize: 10,
          bold: true,
          color: "#000000",
        },
      },
    };
    }
    if (isPrint) {
      pdfMake.createPdf(doc).print();
    } else {
      pdfMake.createPdf(doc).download();
    }
  }
  render() {
    const { asset, type } = this.props;
    this.defaultParams = {
      campaign:
        this.props.room.primaryCampaign || this.props.room.campaigns && this.props.room.campaigns[0]
    };

    const params = Object.assign({}, this.defaultParams, this.state.params);
    const room = Object.assign({}, this.props.room);

    const campaigns = (room.campaigns || []).map(
      campaignId => masterData.campaign.byId[campaignId]
    );
    // HTMLコーディング用に全てを出す
    // if (campaigns.length === 0) {
    //   campaigns.splice(-1, 0, ...masterData.campaign.list.slice(0, 3));
    // }

    const { startDate, endDate } = this.getRange({ asset, params });


    console.log(startDate, endDate);
    // console.log(priceGroups, params);

    const isBank = this.state.params.contractType == BANK ? true : false;

    if (room.vacant !== masterData.vacant.AVAILABLE && this.getParams(room).campaign) {
      this.updateParams({ campaign: null });
    }
    return (
      <div className="modalScrollContainer">
        <div id="printme" className="content">
          <h2>
            {asset.name && (
              <span>
                {asset.name}
              </span>
            )}
            <span style={{ width: "10px", display: "inline-block" }} />
            {room.extent && (
              <span>
                {room.extent}
                帖タイプ
              </span>
            )}
            <span style={{ width: "10px", display: "inline-block" }} />
            {room.floor && (
              <span>
                {room.floor}
                階のお見積もり
              </span>
            )}
          </h2>
          <div>
            <h3>お見積り条件</h3>
            <div className="section collection">
              <div>
                <h4>月々のお支払い方法</h4>
                <div>
                  <OptionButton
                    options={[
                      { slug: CARD, name: "カード" },
                    { slug: BANK, name: "口座引き落し" },
                    ]}
                    value={this.state.params.contractType}
                    onChangeValue={contractType =>
                      this.updateParams({
                        contractType,
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="section">
              <h4>ご利用開始日<br/>
                  ※カードなら最短２日後、口座引き落しなら最短７日後からご利用いただけます。<br/>
                  ※北海道・九州・四国地方はカードの場合最短４日後、口座引き落としの場合最短１０日後からご利用いただけます。</h4>
              <DateSelector
                startDate={startDate}
                endDate={endDate}
                value={this.state.params.startDate}
                onUpdateValue={startDate => this.updateParams({ startDate })}
                isBank={isBank}
              />
              {this.state.showValidation &&
                !this.state.params.startDate && (
                  <div className="errorMessage">選択してください</div>
                )}
            </div>
            {(asset.assetType != 'bikeonly' || asset.bike != 1) && 
            <div>
                <h4>安心保証パックを利用</h4>
                  <div>
                    <table className = "sp_table">
                      <tr>
                        <td className = "warranty">
                        <OptionButton
                          options={[
                          { slug: 1, name: "利用する" },
                          { slug: 3, name: "利用しない" },                  
                          ]}
                          value='1'
                          value={this.state.params.warrantyFlg}
                          onChangeValue={warrantyFlg =>
                            this.updateParams({
                              warrantyFlg,
                            })
                          }
                        />
                        </td>
                        <td className = "warrantyPlus">
                          <br/>
                          さらに充実！<br class="br-sp"></br>安心保証パック＋を利用　
                          <div className = "warrantyPlusBtton">
                          <OptionButton
                            options={[
                            { slug: 4, name: "利用する" },                
                            ]}
                            value={this.state.params.warrantyFlg}
                            onChangeValue={warrantyFlg =>
                              this.updateParams({
                                warrantyFlg,
                              })
                            }
                          /> 
                          </div>                      
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div className = "warrantyNotice">
                    <h4>
                    ※上記いずれかを選択ください。<br/>
                    ※安心保証パック又は、安心保証パック ＋の詳細は<Link to="/anshinpack" target="_blank">こちら</Link><br/>
                    ※安心保証パック又は安心保証パック＋をご利用にならない場合、初期費用に室内整備料8,800円が追加発生いたします。<br/>
                    </h4>
                  </div>
            </div>}
          </div>
          <div className={ type === TYPE_PC ? "sectionGroup" : "" }>
          {campaigns &&
            campaigns.length > 0 && room.vacant === masterData.vacant.AVAILABLE && (
              <div className="sectionCamOp">
                <h3>キャンペーン</h3><br/>
                <h4>適用するキャンペーンを選択してください</h4>
                {campaigns.map((campaign, index) => (
                  <div
                    className={classnames(
                      "campaign",
                      params.campaign === campaign.campaignId && "active"
                    )}
                    onClick={(event, element) => {
                      this.updateParams({ campaign: campaign.campaignId });
                    }}
                  >
                    <div className="campaignTitle">
                      <Checkbox
                        radio
                        style={{}}
                        checked={params.campaign === campaign.campaignId}
                        onChange={(event, element) => {
                          this.updateParams({ campaign: campaign.campaignId });
                        }}
                      />
                      <span>{campaign.campaignName}</span>
                    </div>
                    <div
                      className={classnames(
                        "campaignContent",
                        this.state.detailedCampaign === campaign.campaignId &&
                          "detailed"
                      )}
                    >
                      <div
                        className="campaignText"
                        dangerouslySetInnerHTML={{
                          __html:
                            this.state.detailedCampaign === campaign.campaignId
                              ? campaign.webTokuten
                              : campaign.webTokuten.replace(/<br ?\/?>/g, ""),
                        }}
                      />
                      {this.state.detailedCampaign !== campaign.campaignId && (
                        <div
                          className="campaignMoreButton"
                          onClick={e => {
                            e.stopPropagation();
                            this.showCampaignDetail(campaign.campaignId);
                          }}
                        >
                          適用条件を確認する
                        </div>
                      )}
                      {this.state.detailedCampaign === campaign.campaignId && (
                        <div
                          className="campaignMoreButton"
                          onClick={e => {
                            e.stopPropagation();
                            this.showCampaignDetail(null);
                          }}
                        >
                          閉じる
                        </div>
                      )}
                    </div>
                  </div>
                ))}
                <div
                  className={classnames(
                    "campaign",
                    params.campaign === null && "active"
                  )}
                  onClick={(event, element) => {
                    this.updateParams({ campaign: null });
                  }}
                >
                <div className="campaignTitle">
                  <Checkbox
                    radio
                    style={{}}
                    checked={params.campaign === null}
                    onChange={(event, element) => {
                      this.updateParams({ campaign: null });
                    }}
                  />
                  <span>キャンペーンを適用しない</span>
                </div>
              </div>
            </div>
          )}
          <div className={campaigns &&
            campaigns.length > 0 && room.vacant === masterData.vacant.AVAILABLE ? "sectionCamOp" : "section2"}>
            <h3>オプション</h3><br/>
            <h4>適用するオプションを選択してください</h4>
            <div
              className={classnames(
                "campaign",
                params.rakuraku === true && "active"
              )}
              onClick={(event, element) => {
                if (event.target.tagName !== "A") {
                  if (params.rakuraku === true && (params.packing === true || params.cardboard === true)) {
                    this.updateParams({ rakuraku: !params.rakuraku, packing: false, cardboard: false, cardboardM: 0, cardboardL: 0, cardboardMDisabled: "disabled", cardboardLDisabled: "disabled" });
                  } else {
                    this.updateParams({ rakuraku: !params.rakuraku });
                  }
                }
              }}
            >
              <div className="campaignTitle">
                <Checkbox
                  radio
                  style={{}}
                  checked={params.rakuraku === true}
                  onChange={(event, element) => {
                    if (params.rakuraku === true && (params.packing === true || params.cardboard === true)) {
                      this.updateParams({ rakuraku: !params.rakuraku, packing: false, cardboard: false, cardboardM: 0, cardboardL: 0, cardboardMDisabled: "disabled", cardboardLDisabled: "disabled" });
                    } else {
                      this.updateParams({ rakuraku: !params.rakuraku });
                    }
                  }}
                />
                <span>ハロー宅配便（有料）</span>
                <Link to="/carrieservice/" className="rakurakuDetail" target="_blank">
                  詳細はこちら
                </Link>
              </div>
              {params.rakuraku === true && <div
                className={classnames(
                  "campaignContent",
                  "detailed"
                )}
              >
                <div className="cardboardText">
                  <table className={campaigns &&
                  campaigns.length > 0 && room.vacant === masterData.vacant.AVAILABLE ? "sectionCamOp_table" : "sp_table"}>
                    <tr>
                    <td width="325">
                      運搬荷物サイズをお選びください<br/><br/>
                      <Link to="/simulator" style={{ color: "#4183c4" }} target="_blank">
                        サイズに迷った方はこちら
                      </Link>
                    </td>
                    <td>
                      <div style={{ color: "#f66", fontSize: "12px"}}> 
                        <p>
                        搬出元から搬入先までの運搬距離は最大で50kmです。<br/>
                        50kmを超える場合は別途料金が発生する可能性がございます。<br/>
                        また、お選びいただいたサイズと当日の運搬サイズに大幅な差が生じた場合、<br/>
                        別途運搬料金をご請求する場合がございます。予めご了承ください。
                        </p>
                      </div>
                    </td>
                    </tr>
                  </table>
                  <Table striped unstackable>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell onClick={() => { }}>選択</Table.HeaderCell>
                        <Table.HeaderCell onClick={() => { }}>サイズ</Table.HeaderCell>
                        <Table.HeaderCell onClick={() => { }}>基本料金(税込)</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>
                          <Checkbox
                            radio
                            name="rakurakuJou"
                            value="1"
                            style={{}}
                            checked={params.rakurakuJou === 1}
                            disabled={1 <= this.props.room.extent ? "" : "disabled"}
                            onChange={(event, element) => {
                              this.updateParams({ rakurakuJou: 1 });
                              event.stopPropagation();
                            }}
                          />
                        </Table.Cell>
                        <Table.Cell>
                          1帖以下
                        </Table.Cell>
                        <Table.Cell>
                          23,000円
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <Checkbox
                            radio
                            style={{}}
                            checked={params.rakurakuJou === 1.5}
                            disabled={1.1 <= this.props.room.extent ? "" : "disabled"}
                            onChange={(event, element) => {
                              this.updateParams({ rakurakuJou: 1.5 });
                              event.stopPropagation();
                            }}
                          />
                        </Table.Cell>
                        <Table.Cell>
                          1.1～1.5帖
                        </Table.Cell>
                        <Table.Cell>
                          28,500円
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <Checkbox
                            radio
                            style={{}}
                            checked={params.rakurakuJou === 2}
                            disabled={1.6 <= this.props.room.extent ? "" : "disabled"}
                            onChange={(event, element) => {
                              this.updateParams({ rakurakuJou: 2 });
                              event.stopPropagation();
                            }}
                          />
                        </Table.Cell>
                        <Table.Cell>
                          1.6～2帖
                        </Table.Cell>
                        <Table.Cell>
                          34,000円
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <Checkbox
                            radio
                            style={{}}
                            checked={params.rakurakuJou === 3}
                            disabled={2.1 <= this.props.room.extent ? "" : "disabled"}
                            onChange={(event, element) => {
                              this.updateParams({ rakurakuJou: 3 });
                              event.stopPropagation();
                            }}
                          />
                        </Table.Cell>
                        <Table.Cell>
                          2.1～3帖
                        </Table.Cell>
                        <Table.Cell>
                          38,500円
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <Checkbox
                            radio
                            style={{}}
                            checked={params.rakurakuJou === 4}
                            disabled={3.1 <= this.props.room.extent ? "" : "disabled"}
                            onChange={(event, element) => {
                              this.updateParams({ rakurakuJou: 4 });
                              event.stopPropagation();
                            }}
                          />
                        </Table.Cell>
                        <Table.Cell>
                          3.1～4帖
                        </Table.Cell>
                        <Table.Cell>
                          54,000円
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <Checkbox
                            radio
                            style={{}}
                            checked={params.rakurakuJou === 5}
                            disabled={4.1 <= this.props.room.extent ? "" : "disabled"}
                            onChange={(event, element) => {
                              this.updateParams({ rakurakuJou: 5 });
                              event.stopPropagation();
                            }}
                          />
                        </Table.Cell>
                        <Table.Cell>
                          4.1～5帖
                        </Table.Cell>
                        <Table.Cell>
                          67,500円
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <Checkbox
                            radio
                            style={{}}
                            checked={params.rakurakuJou === 6}
                            disabled={5.1 <= this.props.room.extent ? "" : "disabled"}
                            onChange={(event, element) => {
                              this.updateParams({ rakurakuJou: 6 });
                              event.stopPropagation();
                            }}
                          />
                        </Table.Cell>
                        <Table.Cell>
                          5.1～6帖
                        </Table.Cell>
                        <Table.Cell>
                          81,000円
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <Checkbox
                            radio
                            style={{}}
                            checked={params.rakurakuJou === 7}
                            disabled={6.1 <= this.props.room.extent ? "" : "disabled"}
                            onChange={(event, element) => {
                              this.updateParams({ rakurakuJou: 7 });
                              event.stopPropagation();
                            }}
                          />
                        </Table.Cell>
                        <Table.Cell>
                          6.1～7帖
                        </Table.Cell>
                        <Table.Cell>
                          94,500円
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          <Checkbox
                            radio
                            style={{}}
                            checked={params.rakurakuJou === 7.1}
                            disabled={7.1 <= this.props.room.extent ? "" : "disabled"}
                            onChange={(event, element) => {
                              this.updateParams({ rakurakuJou: 7.1 });
                              event.stopPropagation();
                            }}
                          />
                        </Table.Cell>
                        <Table.Cell>
                          7.1帖～
                        </Table.Cell>
                        <Table.Cell>
                          121,500円
                        </Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </div>
              </div>}
            </div>
            {asset.packingKbn && (<div
              className={classnames(
                "campaign",
                params.packing === true && "active"
              )}
              onClick={(event, element) => {
                if (event.target.tagName !== "A") {
                  if (params.rakuraku === true) {
                    this.updateParams({ packing: !params.packing });
                  }
                }
              }}
            >
              <div className="campaignTitle">
                <Checkbox
                  radio
                  style={{}}
                  checked={params.packing === true}
                  onChange={(event, element) => {
                    if (params.rakuraku === true) {
                      this.updateParams({ packing: !params.packing });
                    }
                  }}
                />
                <span>梱包サービス（有料）</span>
                <Link to="/carrieservice/" className="rakurakuDetail" target="_blank">
                  詳細はこちら
                </Link>
              </div>
            </div>)}
            <div
              className={classnames(
                "campaign",
                params.cardboard === true && "active"
              )}
              onClick={(event, element) => {
                if (params.rakuraku === true) {
                  if (!params.cardboard) {
                    this.updateParams({ cardboard: !params.cardboard, cardboardMDisabled: "", cardboardLDisabled: "" });
                  } else {
                    this.updateParams({ cardboard: !params.cardboard, cardboardM: 0, cardboardL: 0, cardboardMDisabled: "disabled", cardboardLDisabled: "disabled"});
                  }
                }
              }}
            >
              <div className="campaignTitle">
                <Checkbox
                  radio
                  style={{}}
                  checked={params.cardboard === true}
                  onChange={(event, element) => {
                    if (params.rakuraku === true) {
                      if (!params.cardboard) {
                        this.updateParams({ cardboard: !params.cardboard, cardboardMDisabled: "", cardboardLDisabled: "" });
                      } else {
                        this.updateParams({ cardboard: !params.cardboard, cardboardM: 0, cardboardL: 0, cardboardMDisabled: "disabled", cardboardLDisabled: "disabled"});
                      }
                    }
                  }}
                />
                <span>梱包用段ボール購入（有料）</span>
              </div>
              {params.cardboard === true && <div
                className={classnames(
                  "campaignContent",
                  "detailed"
                )}
              >
                <div className="cardboardText">
                  ※ハロー宅配便にお申し込みされる方が対象です<br/>
                  ※段ボールは合計30枚までご注文いただけます<br/><br/>
                  　Ｍサイズ(150円)
                  <Dropdown
                    className="dropdownStyleBlock"
                    value={params.cardboardM}
                    key="0"
                    placeholder="0"
                    options={params.cardboardMOptions}
                    inline
                    disabled={params.cardboardMDisabled}
                    onChange={(event, element) => {
                      if (params.cardboardM > getOptions(31 - element.value)) {
                        this.updateParams({ cardboardL: element.value, cardboardL: 31 - element.value - 1, cardboardMOptions: getOptions(31 - element.value) });
                      } else {
                        this.updateParams({ cardboardM: element.value, cardboardLOptions: getOptions(31 - element.value) });
                      }
                    }}
                  />
                  枚<br/>
                  　Ｌサイズ(200円)
                  <Dropdown
                    className="dropdownStyleBlock"
                    value={params.cardboardL}
                    key="0"
                    placeholder="0"
                    options={params.cardboardLOptions}
                    inline
                    disabled={params.cardboardLDisabled}
                    onChange={(event, element) => {
                      if (params.cardboardM > getOptions(31 - element.value)) {
                        this.updateParams({ cardboardL: element.value, cardboardM: 31 - element.value - 1, cardboardMOptions: getOptions(31 - element.value) });
                      } else {
                        this.updateParams({ cardboardL: element.value, cardboardMOptions: getOptions(31 - element.value) });
                      }
                    }}
                  />
                  枚<br/>
                  　Ｍサイズ：幅 434mm x 奥行 314mm x 高さ 289mm<br/>
                  　Ｌサイズ：幅 495mm x 奥行 345mm x 高さ 493mm
                </div>
              </div>}
              <br/>
              <div style={{color: 'red'}}>無料運搬キャンペーンを選択された場合、オプションでのハロー宅配便お申込みは不要です。</div>
            </div>
            {asset.isRegistFelicaObject == 1 &&
                (<div
                  className={classnames(
                    "campaign",
                    params.felicaCardFlg === true && "active"
                  )}
                  onClick={(event, element) => {
                      if (!params.felicaCardFlg) {
                        this.updateParams({ felicaCardFlg: !params.felicaCardFlg, felicaCardCountDisabled: "" });
                        this.felicaCardCalculation(1);
                      } else {
                        this.updateParams({ felicaCardFlg: !params.felicaCardFlg, felicaCardCount: 1, felicaCardCountDisabled: "disabled" });
                        this.felicaCardCalculation(0);
                      }
                  }}
                >
                    <div className="campaignTitle">
                      <Checkbox
                        radio
                        style={{}}
                        checked={params.felicaCardFlg === true}
                        onChange={(event, element) => {
                            if (!params.felicaCardFlg) {
                                this.updateParams({ felicaCardFlg: !params.felicaCardFlg, felicaCardCountDisabled: "" });
                                this.felicaCardCalculation(1);
                              } else {
                                this.updateParams({ felicaCardFlg: !params.felicaCardFlg, felicaCardCount: 1, felicaCardCountDisabled: "disabled" });
                                this.felicaCardCalculation(0);
                            }
                        }}
                      />
                      {/* スマホ画面だと「詳細はこちら」ボタンと↓文字が被るため全角スペース追加 */}
                      <span>新しい交通系 IC カードを購入　　　　　</span>
                        <div
                          className="rakurakuDetail"
                          onClick={e => {
                              e.stopPropagation();
                              window.open("/app/");
                          }}
                        >
                        詳細はこちら
                        </div>
                    </div>
                    <div
                      className={classnames(
                        "campaignContent",
                        "detailed"
                      )}
                    >
                      <div className="cardboardText">
                        <Dropdown
                          className="dropdownStyleBlock"
                          value={params.felicaCardCount}
                          key="0"
                          placeholder="1"
                          options={params.felicaCardCountOptions}
                          inline
                          disabled={params.felicaCardCountDisabled}
                          onChange={(event, element) => {
                              this.updateParams({ felicaCardCount: element.value });
                              this.felicaCardCalculation(element.value)
                          }}
                        />
                        枚
                        <span id="felicaCardCalculation"></span>
                      </div>
                    </div>
                </div>
            )}
            {asset.rackserviceKbn && 
            (<div
              onClick={(event, element) => {
                  if (!params.rackService) {
                    this.updateParams({ rackService: !params.rackService, rackSmallDisabled: "", rackMediumDisabled: "", rackBigDisabled: "", rackHangerDisabled: "", casterDisabled: "", storageCaseDisabled: "", storageboxSmallDisabled: "", storageboxMediumDisabled: ""});
                  } else {
                    this.updateParams({ rackService: !params.rackService, rackSmall: 0, rackMedium: 0, rackBig: 0, rackHanger: 0, caster: 0, storageCase: 0, storageboxSmall: 0, storageboxMedium: 0, rackSmallDisabled: "disabled", rackMediumDisabled: "disabled", rackBigDisabled: "disabled", rackHangerDisabled: "disabled", casterDisabled: "disabled", storageCaseDisabled: "disabled", storageboxSmallDisabled: "disabled", storageboxMediumDisabled: "disabled"});
                  }
              }}
            >
              <div className="campaignTitle">
                <Checkbox
                  radio
                  style={{}}
                  checked={params.rackService === true}
                  onChange={(event, element) => {
                    
                      if (!params.rackService) {
                        this.updateParams({ rackService: !params.rackService, rackSmallDisabled: "", rackMediumDisabled: "", rackBigDisabled: "", rackHangerDisabled: "", casterDisabled: "", storageCaseDisabled: "", storageboxSmallDisabled: "", storageboxMediumDisabled: ""});
                      } else {
                        this.updateParams({ rackService: !params.rackService, rackSmall: 0, rackMedium: 0, rackBig: 0, rackHanger: 0, caster: 0, storageCase: 0, storageboxSmall: 0, storageboxMedium: 0, rackSmallDisabled: "disabled", rackMediumDisabled: "disabled", rackBigDisabled: "disabled", rackHangerDisabled: "disabled", casterDisabled: "disabled", storageCaseDisabled: "disabled", storageboxSmallDisabled: "disabled", storageboxMediumDisabled: "disabled"});
                      }
                    }
                  }
                />
                
                <span>ラック販売・組み立て<br class="br-sp"></br>サービス　　　　</span>
                <div
                          className="rakurakuDetail"
                          onClick={e => {
                              e.stopPropagation();
                              window.open("/trunkwithrack#rackSellInfo");
                          }}
                        >
                        詳細はこちら
                </div>
              </div>
              {params.rackService === true && <div
                className={classnames(
                  "campaignContent",
                  "detailed"
                )}
              >
                <div className="rackText">
                  ラックサイズ・ご購入希望の収納グッズをお選びください。<br/>
                  ラックは最大10台、収納グッズは最大20個までご注文いただけます。<br/>
                  <Table striped unstackable>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell onClick={() => { }}>サイズ</Table.HeaderCell>
                        <Table.HeaderCell onClick={() => { }}>基本料金(税込)</Table.HeaderCell>
                        <Table.HeaderCell onClick={() => { }}>台数</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                      <Table.Row>
                        <Table.Cell>
                          　小
                        </Table.Cell>
                        <Table.Cell>
                          15,000円
                        </Table.Cell>
                        <Table.Cell>
                            <Dropdown
                            className="dropdownStyleBlock"
                            value={params.rackSmall}
                            key="0"
                            placeholder="0"
                            options={params.rackSmallOptions}
                            inline
                            disabled={params.rackSmallDisabled}
                            onChange={(event, element) => {
                              this.updateParams({ 
                                rackSmall: element.value, 
                                rackBigOptions: getOptions(11 - element.value - params.rackMedium　- params.rackHanger) ,
                                rackMediumOptions: getOptions(11 - element.value - params.rackBig - params.rackHanger) ,
                                rackHangerOptions: getOptions(11 - element.value - params.rackMedium - params.rackBig) 
                              });
                            }}
                          />
                          台
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          　中
                        </Table.Cell>
                        <Table.Cell>
                          15,500円
                        </Table.Cell>
                        <Table.Cell>
                            <Dropdown
                            className="dropdownStyleBlock"
                            value={params.rackMedium}
                            key="0"
                            placeholder="0"
                            options={params.rackMediumOptions}
                            inline
                            disabled={params.rackMediumDisabled}
                            onChange={(event, element) => {
                              this.updateParams({ 
                                rackMedium: element.value, 
                                rackSmallOptions: getOptions(11 - element.value - params.rackBig - params.rackHanger) ,
                                rackBigOptions: getOptions(11 - element.value - params.rackSmall - params.rackHanger) ,
                                rackHangerOptions: getOptions(11 - element.value - params.rackSmall - params.rackBig) 
                              });
                            }}
                          />
                          台
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                          　大
                        </Table.Cell>
                        <Table.Cell>
                          17,000円
                        </Table.Cell>
                        <Table.Cell>
                          <Dropdown
                                className="dropdownStyleBlock"
                                value={params.rackBig}
                                key="0"
                                placeholder="0"
                                options={params.rackBigOptions}
                                inline
                                disabled={params.rackBigDisabled}
                                onChange={(event, element) => {
                                  this.updateParams({ 
                                    rackBig: element.value, 
                                    rackSmallOptions: getOptions(11 - element.value - params.rackMedium - params.rackHanger) ,
                                    rackMediumOptions: getOptions(11 - element.value - params.rackSmall - params.rackHanger) ,
                                    rackHangerOptions: getOptions(11 - element.value - params.rackSmall - params.rackMedium) 
                                  });
                                }}
                              />
                            台
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell className="rackTable">
                        ハンガーラックタイプ
                        </Table.Cell>
                        <Table.Cell>
                          17,000円
                        </Table.Cell>
                        <Table.Cell>
                          <Dropdown
                                className="dropdownStyleBlock"
                                value={params.rackHanger}
                                key="0"
                                placeholder="0"
                                options={params.rackHangerOptions}
                                inline
                                disabled={params.rackHangerDisabled}
                                onChange={(event, element) => {
                                  this.updateParams({ 
                                    rackHanger: element.value, 
                                    rackSmallOptions: getOptions(11 - element.value - params.rackMedium - params.rackBig) ,
                                    rackMediumOptions: getOptions(11 - element.value - params.rackSmall - params.rackBig) ,
                                    rackBigOptions: getOptions(11 - element.value - params.rackSmall - params.rackMedium) 
                                  });
                                }}
                              />
                            台
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell className="rackTable">
                        キャスター
                        </Table.Cell>
                        <Table.Cell>
                          1,100円
                        </Table.Cell>
                        <Table.Cell>
                          <Dropdown
                                className="dropdownStyleBlock"
                                value={params.caster}
                                key="0"
                                placeholder="0"
                                options={params.casterOptions}
                                inline
                                disabled={params.casterDisabled}
                                onChange={(event, element) => {
                                  this.updateParams({ 
                                    caster: element.value, 
                                   });
                                }}
                              />
                            セット
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell className="rackTable">
                        収納ケース
                        </Table.Cell>
                        <Table.Cell>
                          750円
                        </Table.Cell>
                        <Table.Cell>
                          <Dropdown
                                className="dropdownStyleBlock"
                                value={params.storageCase}
                                key="0"
                                placeholder="0"
                                options={params.storageCaseOptions}
                                inline
                                disabled={params.storageCaseDisabled}
                                onChange={(event, element) => {
                                  this.updateParams({ 
                                    storageCase: element.value, 
                                    storageboxSmallOptions: getOptions(21 - element.value -  params.storageboxMedium) ,
                                    storageboxMediumOptions: getOptions(21 - element.value -  params.storageboxSmall) 
                                   });
                                }}
                              />
                            個
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell className="rackTable">
                        収納ボックス小
                        </Table.Cell>
                        <Table.Cell>
                          1,100円
                        </Table.Cell>
                        <Table.Cell>
                          <Dropdown
                                className="dropdownStyleBlock"
                                value={params.storageboxSmall}
                                key="0"
                                placeholder="0"
                                options={params.storageboxSmallOptions}
                                inline
                                disabled={params.storageboxSmallDisabled}
                                onChange={(event, element) => {
                                  this.updateParams({ 
                                    storageboxSmall: element.value, 
                                    storageCaseOptions: getOptions(21 - element.value -  params.storageboxMedium) ,
                                    storageboxMediumOptions: getOptions(21 - element.value -  params.storageCase) 
                                   });
                                }}
                              />
                            個
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell className="rackTable">
                        収納ボックス中
                        </Table.Cell>
                        <Table.Cell>
                          1,500円
                        </Table.Cell>
                        <Table.Cell>
                          <Dropdown
                                className="dropdownStyleBlock"
                                value={params.storageboxMedium}
                                key="0"
                                placeholder="0"
                                options={params.storageboxMediumOptions}
                                inline
                                disabled={params.storageboxMediumDisabled}
                                onChange={(event, element) => {
                                  this.updateParams({ 
                                    storageboxMedium: element.value, 
                                    storageCaseOptions: getOptions(21 - element.value -  params.storageboxSmall) ,
                                    storageboxSmallOptions: getOptions(21 - element.value -  params.storageCase) 
                                   });
                                }}
                              />
                            個
                        </Table.Cell>
                      </Table.Row>                     
                      </Table.Body>
                    </Table>
                  　サイズ小：幅 46cm x 奥行 30cm x 高さ 159.5cm<br/>
                  　サイズ中：幅 67cm x 奥行 30cm x 高さ 159.5cm<br/>
                  　サイズ大：幅 115cm x 奥行 40cm x 高さ 181.5cm<br/>
                  　ハンガーラックタイプ：幅 90.5cm x 奥行 45.5cm x 高さ 181.5cm<br/>
                  　収納ケース：幅 38.7cm x 奥行 26.5cm x 高さ 23.5cm<br/>
                  　収納ボックス小：幅 25.5cm x 奥行 39.5cm x 高さ 23.5cm<br/>
                  　収納ボックス中：幅 51cm x 奥行 39.5cm x 高さ 23.5cm<br/>                             
                  　※キャスターは1セットにつき4つ車輪がついています。
                </div>
              </div>}
            </div>)}
          </div>
          </div>

          <div className="collection buttons" id="button1">
            <div
              className="item"
              onClick={() => {
                this.calculateEstimate();
              }}
            >
              お見積りを表示する
            </div>
          </div>
          {this.state.simulation && (
            <div ref="simulation">
              <h3>お見積り金額</h3>
              <div className="collection">
                <div className="estimation">
                  <div className="estimationHeader">初回のお支払い</div>
                  <div className="estimationContent">
                    <table>
                      <tbody>
                        <tr>
                          <th>事務手数料</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.initialCost.commitionFee
                            )}
                            円
                          </td>
                        </tr>
                        <tr>
                          <th>日割使用料（初月）</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.initialCost.initialPrice
                            )}
                            円
                          </td>
                        </tr>
                        <tr>
                          <th>管理費（初月）</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.initialCost.admissionFee1
                            )}
                            円
                          </td>
                        </tr>
                        <tr>
                          <th>使用料（次月）</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.initialCost.priceMonth
                            )}
                            円
                          </td>
                        </tr>
                        <tr>
                          <th>管理費（次月）</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.initialCost.admissionFee2
                            )}
                            円
                          </td>
                        </tr>
                        <tr>
                          <th>安心保証パック（初月）</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.initialCost.warranty1
                            )}
                            円
                          </td>
                        </tr>
                        <tr>
                          <th>安心保証パック（次月）</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.initialCost.warranty2
                            )}
                            円
                          </td>
                        </tr>
                        <tr>
                          <th>室内整備料</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.initialCost.room_mainte
                            )}
                            円
                          </td>
                        </tr>
                        <tr>
                          <th>鍵買取料</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.initialCost.keyPrice
                            )}
                            円
                          </td>
                        </tr>
                        {this.state.simulation.initialCost.securityFee > 0 && (
                          <tr>
                            <th>セキュリティ登録料 </th>
                            <td>
                              {toLocaleString(
                                this.state.simulation.initialCost.securityFee
                              )}
                              円
                            </td>
                          </tr>
                        )}
                        {this.state.simulation.initialCost.rakuraku > 0 && <tr>
                          <th>ハロー宅配便</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.initialCost.rakuraku
                            )}
                            円
                          </td>
                        </tr>}
                        {this.state.simulation.initialCost.packing > 0 && <tr>
                          <th>梱包サービスプラス</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.initialCost.packing
                            )}
                            円
                          </td>
                        </tr>}
                        {this.state.simulation.initialCost.cardboard > 0 && <tr>
                          <th>梱包用段ボール</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.initialCost.cardboard
                            )}
                            円
                          </td>
                        </tr>}
                        {this.state.simulation.initialCost.rackService > 0 && <tr>
                          <th>ラック販売・組み立てサービス</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.initialCost.rackService
                            )}
                            円
                          </td>
                        </tr>}
                        <tr className="discount">
                          <th>Web申し込み割引</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.initialCost.discountWeb
                            )}
                            円
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table className="summary">
                      <tbody>
                        <tr>
                          <th>初回のお支払い</th>
                          <td>
                            <span className="value">
                              {toLocaleString(
                                this.state.simulation.initialCost.total
                              )}
                            </span>
                            円
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {this.state.simulation.initialCost.discountTotal > 0 && (
                      <div className="discountSummary">
                        {toLocaleString(
                          this.state.simulation.initialCost.discountTotal
                        )}
                        円お得！
                        <img src="resource/img/hand.png" />
                      </div>
                    )}
                  </div>
                </div>
                <div style={{ width: "10px", flex: "none" }} />
                <div>
                <div className="estimation">
                  <div className="estimationHeader">月々のお支払い{(this.state.simulation.runningCostWithoutCampaign && this.state.simulation.runningCost.discountTotal > 0) && <span>(キャンペーン適用中)</span>}</div>
                  <div className="estimationContent">
                    <table>
                      <tbody>
                        <tr>
                          <th>月額使用料</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.runningCost.priceMonth
                            )}
                            円
                          </td>
                        </tr>
                        <tr>
                          <th>管理費</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.runningCost.admissionFee
                            )}
                            円
                          </td>
                        </tr>
                        <tr>
                          <th>安心保証パック</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.runningCost.warranty
                            )}
                            円
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table className="summary">
                      <tbody>
                        <tr>
                          <th>月々のお支払い</th>
                          <td>
                            <span className="value">
                              {toLocaleString(
                                this.state.simulation.runningCost.total
                              )}
                            </span>
                            円
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {this.state.simulation.runningCost.discountTotal > 0 && (
                      <div className="discountSummary">
                        {toLocaleString(
                          this.state.simulation.runningCost.discountTotal
                        )}
                        円お得！
                        <img src="resource/img/hand.png" />
                      </div>
                    )}
                  </div>
                </div>
                {(this.state.simulation.runningCostWithoutCampaign && this.state.simulation.runningCost.discountTotal > 0) && (<div className="estimationAfter">
                  <div className="estimationAfterCampaignHeader">月々のお支払い(キャンペーン適用終了後)</div>
                  <div className="estimationAfterCampaignContent">
                    <table>
                      <tbody>
                        <tr>
                          <th>月額使用料</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.runningCostWithoutCampaign.notCampaignPriceMonth
                            )}
                            円
                          </td>
                        </tr>
                        <tr>
                          <th>管理費</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.runningCostWithoutCampaign.notCampaignAdmissionFee
                            )}
                            円
                          </td>
                        </tr>
                        <tr>
                          <th>安心保証パック</th>
                          <td>
                            {toLocaleString(
                              this.state.simulation.runningCostWithoutCampaign.notCampaignWarranty
                            )}
                            円
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table className="summary">
                      <tbody>
                        <tr>
                          <th>月々のお支払い</th>
                          <td>
                            <span className="value">
                              {toLocaleString(
                                this.state.simulation.runningCostWithoutCampaign.notCampaignTotal
                              )}
                            </span>
                            円
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              </div>
              </div>

              <div className="notice">
                ※安心保証パックの詳細は<Link to="/anshinpack"　target="_blank">こちら</Link>
                <br />
                ※計算結果は、目安の利用料金となります。詳しくはお問い合わせ下さい。
                <br />
                ※鍵代は物件によっては発生致しません。詳細はお問合せの際にご確認下さい。
                <br />
                ※月々の支払い方法がお引き落としの場合は、別途引落手数料が発生致します。
                <br />
                ※お申込内容により、保証会社を付帯させていただく場合がございます(別途､保証委託料がかかります)。
                <br />
                ※鍵買取料に関して、南京錠・交通系ICカード等の鍵購入費用が合算で表記されております。
                <br />
                {this.state.simulation.initialCost.securityFee > 0 &&
                  "※セキュリティカードキーが必要になる物件につきまして、カードキーはレンタルとなります。\n"}
                {this.state.simulation.initialCost.total == 1 &&
                  "※決済処理調整を行うため、1円での決済となります。"}
                <br />
                ※表記はすべて「税込み価格」です。
                <br />
              </div>

              <div className="collection buttons" id="button2">
                {room.vacant == 0 &&
                <div
                  className="item"
                  onClick={() => {
                    applyRoom(room, asset, type, this.getParams(room).contractType, this.getParams(room).startDate.replace(/\//g, ""), this.getParams(room).campaign, params.rakuraku, params.rakurakuJou, params.packing, params.cardboard, params.cardboardM, params.cardboardL, params.felicaCardFlg, params.felicaCardCount , params.warrantyFlg, params.rackService, params.rackSmall, params.rackMedium, params.rackBig, params.rackHanger, params.caster, params.storageCase, params.storageboxSmall, params.storageboxMedium);
                  }}
                >
                  お申し込みする
                </div>}
                {(type === TYPE_PC && !this.state.params.isIEorEdgeorOghers) && <div className="item" onClick={() => this.GeneratePdfFromHtml(asset, room, this.state, startDate, true)}>
                  お見積りを印刷
                </div>}
                {(type === TYPE_PC) && <div className="item" onClick={() => this.GeneratePdfFromHtml(asset, room, this.state, startDate, false)}>
                  お見積りをダウンロード
                </div>}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export const modal_estimate = props => {
  return (
    <div className="modal_estimate modal_base">
      <div className="cross" onClick={() => modal.closeModal()} />
      <ModalEstimate {...props} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./common/modal/modal_estimate.jsx